import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isProcessingRouteAllowed } from '../navigation/accessRules';

function ProtectedRoute({ children }) {
    const { currentUser } = useAuth();
    const location = useLocation();

    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    if (currentUser.accessProfile === 'processing' && !isProcessingRouteAllowed(location.pathname)) {
        return <Navigate to="/offers/bundle-builder-beta" replace />;
    }

    return children;
}

export default ProtectedRoute;
